import { Component, OnInit } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { ModalController } from '@ionic/angular';
import { StorageService } from 'src/app/core/services/storage.service';

@Component({
  selector: 'app-card-details',
  templateUrl: './card-details.page.html',
  styleUrls: ['./card-details.page.scss'],
  standalone: false,
})
export class CardDetailsPage implements OnInit {
  cardNumber: string;

  constructor(
    private modalCtrl: ModalController,
    private storageService: StorageService
  ) {}

  async ngOnInit() {
    this.cardNumber =
      (await this.storageService.get('card-reader-number')) || '';
  }

  closeModal() {
    this.modalCtrl.dismiss();
  }

  async save() {
    if (!this.cardNumber) return;
    await this.storageService.set('card-reader-number', this.cardNumber);
    this.closeModal();
  }
}
